import GLU from '../glu2.js/src/index';
import Api from '../apis/Api';
import SearchLimits from '../enums/SearchLimit';
import AppConfig from '../appConfig';

class SearchDataSource extends GLU.DataSource {
    static get name() {
        return 'SearchDataSource';
    }

    static getInstance() {
        return new SearchDataSource();
    }

    constructor() {
        super();
        this._recentSearchTerms = [];
    }

    get recentSearchTerms() {
        return this._recentSearchTerms;
    }

    addRecentSearchTerm(searchTerm) {
        const recentSearchTermIndex = this._recentSearchTerms.findIndex(
            term => term === searchTerm,
        );

        if (recentSearchTermIndex === -1) {
            // add new term
            this._recentSearchTerms.unshift(searchTerm);
        } else {
            // push it to the top
            this._recentSearchTerms.splice(recentSearchTermIndex, 1);
            this._recentSearchTerms.unshift(searchTerm);
        }

        if (this._recentSearchTerms.length > SearchLimits.RECENT_SEARCHES_LIMIT) {
            this._recentSearchTerms.pop();
        }

        return this._recentSearchTerms;
    }

    async hereGeocode({ searchTerm, limit = 10 }) {
        try {
            const response = await fetch(
                `${AppConfig.constants.backends.accounts}/geocode/search?q=${encodeURIComponent(
                    searchTerm,
                )}&limit=${limit}`,
            );
            if (!response.ok) throw new Error('Geocode failed');
            const data = await response.json();
            return { data: data.items || [], query: searchTerm };
        } catch (err) {
            console.error('hereGeocode error', err);
            return { data: [], query: searchTerm };
        }
    }

    async hereReverseGeocode({ point }) {
        try {
            const response = await fetch(
                `${AppConfig.constants.backends.accounts}/geocode/reverse?lat=${point.lat}&lng=${point.lng}`,
            );
            if (!response.ok) throw new Error('Reverse geocode failed');
            const data = await response.json();

            if (data.items && data.items.length > 0) {
                const location = data.items[0];
                if (location.resultType !== 'administrativeArea') {
                    return location.address;
                }
            }
            return null;
        } catch (err) {
            console.error('hereReverseGeocode error', err);
            return null;
        }
    }
}

export default SearchDataSource;
